// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2213":"2abd8cde","3973":"66b7a109","4044":"9005aab6"}[chunkId] + ".chunk.css";
};